export default __webpack_public_path__ + "static/media/amazon-chromecast.3c384972.jpg";